export default __webpack_public_path__ + "static/media/elena-with-iso.0557adf1.jpg";